import { createFileRoute } from "@tanstack/react-router";
import { MessagesSquare } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Ask } from "@/features/research/modules/ask/ask";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/ask/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.research_ask_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={MessagesSquare} title={m.research_ask_title()} description={m.research_ask_description()}>
      <Ask />
    </PageShell>
  );
}
